
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsConfigTypeDialog extends Serenity.EntityDialog<PsConfigTypeRow, any> {
        protected getFormKey() { return PsConfigTypeForm.formKey; }
        protected getIdProperty() { return PsConfigTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsConfigTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsConfigTypeRow.nameProperty; }
        protected getService() { return PsConfigTypeService.baseUrl; }
        protected getDeletePermission() { return PsConfigTypeRow.deletePermission; }
        protected getInsertPermission() { return PsConfigTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsConfigTypeRow.updatePermission; }

        protected form = new PsConfigTypeForm(this.idPrefix);

    }
}